import React from "react";
import {
  Shimmer,
  SkeletonDiscuss,
  SkeletonElement,
  SkeletonSugestedCom,
} from "..";

const DiscussLoader: React.FC = () => {
  return (
    <div className="flex flex-row w-[90%] mx-auto justify-between justify-items-center py-16">
      <div className="w-[23%] flex flex-col h-fit bg-white pt-1 pb-2 pl-1">
        <div className="mb-3 ml-1">
          <SkeletonElement type="title" />
        </div>
        {[1, 2, 3].map((n) => (
          <SkeletonSugestedCom key={n} />
        ))}
      </div>
      <div className="flex w-[45%] flex-col gap-3 relative">
        <div className="w-[97%] px-5 flex justify-center">
          <div className="bg-white rounded w-full shadow-sm flex h-10 items-center pl-10">
            <div className="flex-1 ">
              <SkeletonElement type="title" />
            </div>
            <div className="flex-1 ">
              <SkeletonElement type="title" />
            </div>
          </div>
        </div>
        <div className="flex w-full flex-col gap-3 mb-4">
          <div className="shadow-sm w-full rounded-sm bg-white px-4 py-1">
            <SkeletonSugestedCom />
          </div>
          <div className="relative w-full overflow-hidden">
            <div className="w-[110%]">
              <SkeletonElement type="image" />
            </div>
            <div className="flex items-center mt-3 bg-white w-full rounded-sm h-[38px] pl-[17px]">
              <SkeletonElement type="title" />
            </div>
            <Shimmer />
          </div>
          <div className="gap-4 relative overflow-hidden w-full">
            <SkeletonElement type="title" />
            <div className="h-10 flex justify-between items-center mt-4 w-full">
              <div className="flex items-center gap-7">
                <SkeletonElement type="menu" />
                <div className="ml-[-52px]">
                  <SkeletonElement type="menu" />
                </div>
                <div className="ml-[-52px]">
                  <SkeletonElement type="menu" />
                </div>
                <div className="ml-[-52px]">
                  <SkeletonElement type="menu" />
                </div>
                <SkeletonElement type="icon" />
              </div>
              <div className="flex gap-3">
                <SkeletonElement type="icon" />
                <SkeletonElement type="icon" />
              </div>
            </div>
            <div className="w-full flex justify-center mt-4">
              <div className="bg-white rounded w-full shadow-sm flex h-10 items-center pl-5">
                <div className="flex-1 ">
                  <SkeletonElement type="title" />
                </div>
                <div className="flex-1 ">
                  <SkeletonElement type="title" />
                </div>
                <div className="flex-1 ">
                  <SkeletonElement type="title" />
                </div>
                <div className="flex-1 ">
                  <SkeletonElement type="title" />
                </div>
              </div>
            </div>
            <div className="shadow-sm w-full flex items-center gap-4 rounded-sm bg-white px-4 py-1 mt-4">
              <SkeletonElement type="menu" />
              <SkeletonElement type="title" />
            </div>
            <Shimmer />
          </div>
          <div className="bg-white">
            <SkeletonDiscuss />
          </div>
        </div>
      </div>
      <div className="w-[23%] flex flex-col  ">
        <div className=" w-full relative overflow-hidden  rounded py-4 px-3 bg-white shadow flex flex-col gap-3 ">
          <SkeletonElement type="icon" />

          <SkeletonElement type="text" />
          <Shimmer />
        </div>
        <div className="mb-3 ml-1 bg-white pt-1 h-fit pb-2 pl-1 mt-4">
          <div className="mb-3 ml-1">
            <SkeletonElement type="title" />
          </div>
          {[1, 2, 3].map((n) => (
            <SkeletonSugestedCom key={n} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DiscussLoader;
